import blogContent1 from "./blogPostContent/blogPost1";
import blogContent2 from "./blogPostContent/blogPost2";
import blogContent3 from "./blogPostContent/blogPost3";
// TODO SAVE THIS IN DATABSE

const posts = [
  {
    title: "This blog article was generated with AI",
    id: 1,
    date: 1653167313,
    src: `${process.env.PUBLIC_URL}/images/logged_out/blogPost1.webp`,
    snippet:
      'As artificial intelligence (AI) becomes more advanced, so too does its ability to generate human-like content. This was recently demonstrated by a blog article that was entirely generated by an AI system. The article, titled "This blog article was generated with AI", was published on the website Filler AI.',
    content: blogContent1,
    url: "this-blog-article-was-generated-with-ai",
  },
  {
    title: "Best AI tool for SEO Content Creation",
    id: 2,
    date: 1654559340,
    src: `${process.env.PUBLIC_URL}/images/logged_out/blogPost2.webp`,
    snippet:
      "As the competition for online traffic continues to increase, the need for effective SEO tools becomes more critical. There are a number of different AI tools available that can help with the creation of SEO content, but which is the best?",
    content: blogContent2,
    url: "best-ai-tool-for-seo",
  },
  {
    title: "Why you Should use Artificial Intelligence for blogging",
    id: 3,
    date: 1654559340,
    src: `${process.env.PUBLIC_URL}/images/logged_out/blogPost3.webp`,
    snippet:
      "The future of blogging is here, and its name is artificial intelligence. That’s right, AI is coming to change the face of blogging as we know it, making the process easier, faster and more effective than ever before.",
    content: blogContent3,
    url: "artificial-intelligence-for-blogging",
  },
  // {
  //   title: "Post 4",
  //   id: 4,
  //   date: 1572281600,
  //   src: `${process.env.PUBLIC_URL}/images/logged_out/blogPost4.jpg`,
  //   snippet:
  //     "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
  //   content: content,
  // },
  // {
  //   title: "Post 5",
  //   id: 5,
  //   date: 1573281600,
  //   src: `${process.env.PUBLIC_URL}/images/logged_out/blogPost5.jpg`,
  //   snippet:
  //     "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
  //   content: content,
  // },
  // {
  //   title: "Post 6",
  //   id: 6,
  //   date: 1575281600,
  //   src: `${process.env.PUBLIC_URL}/images/logged_out/blogPost6.jpg`,
  //   snippet:
  //     "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
  //   content: content,
  // },
];

export default posts;
